// src/components/header/Header.js
import React from 'react'
import { Link } from 'react-router-dom'
import MobileMenu from '../MobileMenu/MobileMenu'
// import HeaderSearchForm from '../HeaderSearchForm/HeaderSearchForm';
import { connect } from "react-redux";
import { removeFromCart } from "../../store/actions/action";

const Header = (props) => {

    const ClickHandler = () => {
        window.scrollTo(10, 0);
    }

    return (
        <header id="header" className={props.hclass}>
            <div className="wpo-site-header">
                <nav className="navigation navbar navbar-expand-lg navbar-light">
                    <div className="container">
                        <div className="row align-items-center">
                            <div className="col-lg-3 col-md-3 col-3 d-lg-none dl-block">
                                <MobileMenu />
                            </div>
                            <div className="col-lg-2 col-md-4 col-6">
                                <div className="navbar-header">
                                    <Link onClick={ClickHandler} className="navbar-brand" to="/">
                                        <img src={props.Logo} alt="logo" />
                                    </Link>
                                </div>
                            </div>
                            <div className="col-lg-2 col-md-8 col-6"></div>
                            <div className="col-lg-8 col-md-8 col-6">
                                <div id="navbar" className="collapse navbar-collapse navigation-holder">
                                    <ul className="nav navbar-nav mb-2 mb-lg-0">
                                        <li className="menu-item-has-children">
                                            <Link onClick={ClickHandler} to="/">Trang chủ</Link>
                                        </li>
                                        <li><Link onClick={ClickHandler} to="/huongdan">Hướng dẫn</Link></li>
                                   
                                        
                                        <li className="menu-item-has-children">
                                            <Link to="#">Công cụ AI</Link>
                                            <ul className="sub-menu">
                                                <li><Link onClick={ClickHandler} to="/image-generate">Thiết kế cùng AI</Link></li>
                                                <li><Link onClick={ClickHandler} to="/image-ai">AI nhận diện</Link></li>
                                            </ul>
                                        </li>
                                        <li><Link onClick={ClickHandler} to="/vr">360</Link></li>
                                        <li><Link onClick={ClickHandler} to="/sanpham">Sản phẩm</Link></li>
                                        <li><Link onClick={ClickHandler} to="/tracnghiem">Trắc nghiệm</Link></li>
                                        <li className="menu-item-has-children">
                                            <Link to="#">Tin tức</Link>
                                            <ul className="sub-menu">
                                            <li><Link onClick={ClickHandler} to="/blog">Bài nghiên cứu</Link></li>
                                            <li><Link onClick={ClickHandler} to="/gallery">Khoảnh khắc</Link></li>
                                            <li><Link onClick={ClickHandler} to="/contact">Liên hệ</Link></li>
                                            </ul>
                                        </li>
                                     
                                    </ul>
                                </div>
                            </div>
                        </div>
                    </div>
                </nav>
            </div>
        </header>
    )
}

const mapStateToProps = (state) => {
    return {
        carts: state.cartList.cart,
    };
};

export default connect(mapStateToProps, { removeFromCart })(Header);
